import axios from 'axios';
import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import Checkbox from 'blocks/Checkbox';
import Col from 'blocks/Col';
import Row, { RowItem } from 'blocks/Row';
import { Title } from 'blocks/Text';
import { SelectField, TextField } from 'components/Form';
import ForgetPasswordModal from 'components/modals/ForgetPasswordModal';
import cookie from 'helper/cookie';
import Paths from 'helper/paths';
// import { useForm } from 'hooks/useForm';
import { uuidv4 } from 'helper/common';
import Auth from 'layouts/Auth';
import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { instance } from 'utils/ajax';
import urls from 'utils/urls';
import { LoginFormModel, LoginTypeOptions, LoginTypes } from './login.interface';
import * as S from './login.styles';

const emailId = uuidv4();

const passwordId = uuidv4();
const Login = () => {
  const forgetPasswordModal = useRef<any>();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loginTypes: LoginTypeOptions[] = [
    { title: t('constants.loginTypes.email'), value: 'email' },
    { title: t('constants.loginTypes.idNumber'), value: 'idNumber' },
  ];

  const { register, handleSubmit, setValue, watch, getValues } = useForm<LoginFormModel>({
    defaultValues: {
      loginType: 'email',
    },
  });

  const login = async (data: LoginFormModel) => {
    setLoading(true);
    const dataToSend = {
      password: data.password || (document.getElementById(passwordId) as HTMLInputElement).value,
    };
    if (data.loginType === 'email') {
      dataToSend['email'] = data.email || (document.getElementById(emailId) as HTMLInputElement).value;
      dataToSend['loginType'] = data.loginType;
    } else {
      dataToSend['idNumber'] = data.idNumber;
      dataToSend['loginType'] = data.loginType;
    }

    axios
      .post(urls.login, dataToSend)
      .then((res) => {
        cookie.set('authorization', res.data.response.token, getValues('remember') ? 30 : 1);
        axios.defaults.headers['authorization'] = `Bearer ${res.data.response.token}`;

        instance.defaults.headers['authorization'] = `Bearer ${res.data.response.token}`;

        navigate(Paths.Main.index().route);
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const SideFooter = () => {
    return (
      <>
        {`${t('pages.login.sections.image.signupDescription')} `}
        <Link to={Paths.Signup.index().route}>{t('pages.login.sections.image.toSignupCTA')}</Link>
      </>
    );
  };

  const LoginForm = () => {
    return (
      <>
        <S.Loginform as={RowItem}>
          <S.LoginLoginBox as={Col} align="stretch">
            <Card space="lg">
              <Col align="stretch">
                <S.LoginTitleLeft as={Title} size="medium" bold={false}>
                  {t('pages.login.sections.form.title')}
                </S.LoginTitleLeft>

                <BoxWrapper>
                  <SelectField
                    label={t('pages.login.sections.form.fields.types.label')}
                    menu={loginTypes}
                    onChange={(value) => {
                      if (value) setValue('loginType', value as LoginTypes);
                    }}
                    defaultValue={loginTypes[0].value}
                  />
                </BoxWrapper>

                <BoxWrapper>
                  {watch('loginType') && getValues('loginType') === 'email' ? (
                    <TextField
                      dir={'ltr'}
                      key="email"
                      id={emailId}
                      label={t('pages.login.sections.form.fields.email.label')}
                      control={register('email')}
                    />
                  ) : (
                    <TextField
                      dir={'ltr'}
                      key="membershipId"
                      label={t('pages.login.sections.form.fields.membershipId.label')}
                      control={register('idNumber')}
                    />
                  )}
                </BoxWrapper>

                <BoxWrapper>
                  <TextField
                    dir={'ltr'}
                    key="password"
                    id={passwordId}
                    label={t('pages.login.sections.form.fields.password.label')}
                    control={register('password')}
                    type="password"
                  />
                </BoxWrapper>

                <BoxWrapper>
                  <Row className="forget-password" justify="space-between">
                    <div className="remember">
                      <Checkbox
                        onChange={(_) => {
                          console.log(_);
                        }}
                        name="remember"
                        value={getValues('remember')}
                        label={t('pages.login.sections.form.fields.rememberMe.label')}
                      />
                    </div>
                    <S.LoginForget onClick={() => forgetPasswordModal.current.openModal()}>
                      {t('pages.login.sections.form.forgotPasswordCTA')}
                    </S.LoginForget>
                  </Row>
                </BoxWrapper>

                <S.LoginButton>
                  <Button
                    width={176}
                    type="button"
                    onClick={handleSubmit((data) => {
                      login(data);
                    })}
                    loading={loading}
                  >
                    {t('pages.login.sections.form.actionButton')}
                  </Button>
                  {/* <S.Newuser as={Link} to={Paths.Signup.index().route}>
                    {t('pages.login.sections.form.newUser')}
                  </S.Newuser> */}
                  <S.sendtosignupPage as={Link} to={Paths.Signup.index().route}>
                    {' '}
                    {t('pages.login.sections.form.signupDescription')}
                  </S.sendtosignupPage>
                  <S.sendtosignupPage target="_blank" href={`https://iranair.com/sky-gift`}>
                    {' '}
                    {t(`layout.mainMenu.Loyal`)}
                  </S.sendtosignupPage>
                </S.LoginButton>
              </Col>
            </Card>
          </S.LoginLoginBox>
        </S.Loginform>
        <ForgetPasswordModal ref={forgetPasswordModal} />
      </>
    );
  };

  return (
    <Auth
      topTitle={t('pages.login.sections.image.topTitle')}
      title={t('pages.login.sections.image.title')}
      children={LoginForm()}
      sideFooter={SideFooter()}
    />
  );
};

export default Login;
